module.exports = __webpack_public_path__ + "static/media/Literature Review Import Template.ad97f0f1.xlsx";